import React from 'react';
import { CompressedTemporalBar } from './atomic/CompressedTemporalBar';
import { TemporalEditor } from './atomic/TemporalEditor';
import { useConfigStore } from '@stores/v4/useConfigStore';

interface TimeInputSystemProps {
    composedEvent: any;
    updateComposedEvent: (updates: any) => void;
    timeIntervals: string[];
    formatDisplayDate: (date: string) => string;
    activeTimePickerModal: 'START' | 'END' | 'DURATION' | null;
    setActiveTimePickerModal: (type: 'START' | 'END' | 'DURATION' | null) => void;
}

/**
 * TimeInputSystem: Polymorphic orchestrator for temporal configuration.
 * V2.0: Modal state lifted to parent for absolute Z-index hardening.
 */
export const TimeInputSystem: React.FC<TimeInputSystemProps> = ({
    composedEvent,
    updateComposedEvent,
    timeIntervals,
    formatDisplayDate,
    activeTimePickerModal,
    setActiveTimePickerModal
}) => {
    const timeInputStyle = useConfigStore(state => state.timeInputStyle);

    return (
        <>
            {/* SELECTION BAR/LIST */}
            {timeInputStyle === 'SMART_WHEEL' ? (
                <CompressedTemporalBar 
                    startDate={composedEvent.startDate}
                    startTime={composedEvent.startTime}
                    endDate={composedEvent.endDate}
                    endTime={composedEvent.endTime}
                    onUpdate={updateComposedEvent}
                    onOpenPicker={setActiveTimePickerModal}
                />
            ) : (
                <TemporalEditor 
                    startDate={composedEvent.startDate}
                    startTime={composedEvent.startTime}
                    endDate={composedEvent.endDate}
                    endTime={composedEvent.endTime}
                    timeIntervals={timeIntervals}
                    formatDisplayDate={formatDisplayDate}
                    onUpdate={updateComposedEvent}
                />
            )}
        </>
    );
};
